require('./scss/style.scss');


var $ = require('jquery');
window.jQuery = $;
window.$ = $;

//require('./js/jquery.filterizr');

const ww = $(window).width();
const wh = $(window).height();


function resizeHero(){

    
    var heroH = $('.the-sidehero').height();
    var heroH2 = $('.the-smallhero').height();
    var heroH3 = $('.txt-sidebar').height();
    var heroImg = $('.heroimg').height();
    

    //console.log(heroImg);

    $('.adjust').css('height', heroH/2);
    $('.adjust1, .adjust2').css('height', heroH2);
    $('.adjust3, .adjust4').css('height', heroH3-heroImg);
}




$(document).ready(function() {

    //$('.filtr-container').filterizr();


    $(".menu-toggle").on("click", function(a) {
        a.preventDefault();
        $("nav").toggleClass("visible");
        $("body").toggleClass("nav-is-open")
    });

    var currentImg = $(".hero-img").attr("src");

    if (currentImg) {
        var heroImg = new Image();
        heroImg.src = currentImg;
        $('.hero-add').css('background-image', 'url(' + currentImg + ')');

        heroImg.onload = function(){
            //console.log(this.width, this.height);
             $('.hero-img-wrap').addClass('herobg');   
        }    
    }

    if (ww >= 1024) {
        resizeHero();
    }

    window.addEventListener('resize', function () {

        console.log(ww,wh);

        if (ww >= 1024) {
            resizeHero();
        }

    }, false);


    // Show the first tab and hide the rest
    $('#tabs-nav li:first-child').addClass('active');
    $('.tab-content').hide();
    $('.tab-content:first').show();

    // Click function
    $('#tabs-nav li').click(function(){
      $('#tabs-nav li').removeClass('active');
      $(this).addClass('active');
      $('.tab-content').hide();
      
      var activeTab = $(this).find('a').attr('href');
      $(activeTab).fadeIn();
      return false;
    });


});


// WEBPACK FOOTER //
// ./app.js